import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useLocale } from "react-aria";
import { DateFormatter, getLocalTimeZone, isToday, parseAbsolute, toCalendarDate, today } from "@internationalized/date";
import { FlagOutlined, ScheduleOutlined, StarBorder } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { Button, useDeadlineDetails } from "sprout-ui-dom";
import styled from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import { useNavigationListContext } from "@sprout/list-navigation";
const PostPageWhenOrDeadlineButton = styled(Button)`
  padding-left: 8px;
  padding-right: 16px;
  border-radius: 30px;
  background: ${themeGet("colors.white.100")};
`;
const PostPageWhenOrDeadline = (props)=>{
    const { item  } = props;
    const { when , whenReminder , deadline  } = item;
    const authorization = usePostAuthorization(item);
    const { locale  } = useLocale();
    const date = when || whenReminder;
    const whenLabel = useMemo(()=>{
        if (!date) return null;
        const timezone = getLocalTimeZone();
        const todayDate = today(timezone);
        const currentDate = toCalendarDate(parseAbsolute(date, timezone));
        if (isToday(currentDate, timezone)) return "Today";
        else if (todayDate.add({
            days: 1
        }).compare(currentDate) === 0) return "Tomorrow";
        else {
            const notThisYear = currentDate.year > todayDate.year;
            return new DateFormatter(locale, notThisYear ? {
                day: "numeric",
                month: "short",
                year: "numeric"
            } : {
                weekday: "short",
                day: "numeric",
                month: "short"
            }).format(new Date(date));
        }
    }, [
        date,
        locale
    ]);
    const { dispatchCommand  } = useNavigationListContext();
    const handleScheduleClick = useCallback(()=>{
        dispatchCommand("PAGE_WHEN", null);
    }, [
        dispatchCommand
    ]);
    //
    const deadlineDetails = useDeadlineDetails(deadline);
    const handleDeadlineClick = useCallback(()=>{
        dispatchCommand("PAGE_DEADLINE", null);
    }, [
        dispatchCommand
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            whenLabel && /*#__PURE__*/ _jsxs(PostPageWhenOrDeadlineButton, {
                type: "button",
                disabled: !authorization.schedule,
                onClick: handleScheduleClick,
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        color: whenLabel === "Today" ? "yellow.200" : "#f68639",
                        children: whenLabel === "Today" ? /*#__PURE__*/ _jsx(StarBorder, {}) : /*#__PURE__*/ _jsx(ScheduleOutlined, {})
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 1,
                        fontSize: 1,
                        fontWeight: "medium",
                        children: whenLabel
                    })
                ]
            }),
            deadlineDetails && /*#__PURE__*/ _jsxs(PostPageWhenOrDeadlineButton, {
                type: "button",
                disabled: !authorization.schedule,
                onClick: handleDeadlineClick,
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        color: deadlineDetails.moreThan7Days ? "black.60" : "#ff1744",
                        children: /*#__PURE__*/ _jsx(FlagOutlined, {})
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 1,
                        fontSize: 1,
                        fontWeight: "medium",
                        children: deadlineDetails.label
                    })
                ]
            })
        ]
    });
};
export default PostPageWhenOrDeadline;
